export default "__VITE_ASSET__UrtCPseM__"